export enum FilterTypes {
  LAST = 'last',
  MONTHS = 'filter-months',
  CUSTOM_RANGE = 'custom-range',
  YEARS = 'filter-years'
}
